<!-- 查看详细 -->
<template>
<!-- 向上检测父组件方法 -->
  <div class="button" @click="getDetail">
    <div>
      <img style="width:14px;height:16px" src="@/assets/hideBox/detail.png" alt />
      <span>查看详情</span>
    </div>
  </div>
</template>

<script>
import {checkDataStatusMessage} from "@/utils/checkDataStatus"

export default {
  name: "openDetail",
  inject:['cardListCom'],
  props:{
    item:Object
  },
  methods:{
    async getDetail(){
      let no = this.item.no
      if(this.$parent.type==2){
        no = this.item.companyNo
      }
      const dataState = await checkDataStatusMessage.call(this,this.$parent.type,no)
      if(!dataState || dataState!=1){
        return
      }

      this.$parent && this.$parent.$parent && this.$parent.$parent.$parent && this.$parent.$parent.$parent.goDetails(this.item)
    }
  }
}
</script>

<style scoped>

</style>
